export const reservationTypes = {
    GET_UPCOMING_RESERVATIONS: "GET_UPCOMING_RESERVATIONS",
    UPCOMING_RESERVATIONS_NOT_FOUND: "UPCOMING_RESERVATIONS_NOT_FOUND",
    FETCHING_MORE_PAST_RESERVATIONS: "FETCHING_MORE_PAST_RESERVATIONS",
    GET_PAST_RESERVATIONS: "GET_PAST_RESERVATIONS",
    NO_MORE_PAST_RESERVATIONS: "NO_MORE_PAST_RESERVATIONS",
    CLEAR_PAST_RESERVATIONS: "CLEAR_PAST_RESERVATIONS",
    CLEAR_UPCOMING_RESERVATIONS: "CLEAR_UPCOMING_RESERVATIONS",
    CHANGE_AUTH_POP_UP_STATUS: "CHANGE_AUTH_POP_UP_STATUS",
    CHANGE_ACTIVATION_POP_UP_STATUS: "CHANGE_ACTIVATION_POP_UP_STATUS",
};